import io from 'socket.io-client';


export default {

    onNewMessage: async (socket, handleModal) => {
        socket.on('menssage', (data) => {
            if(data.message === "Teste"){
                handleModal()
            }
        })
    },
}